import { render, staticRenderFns } from "./LinesDetails.vue?vue&type=template&id=fa8127e4&"
import script from "./LinesDetails.vue?vue&type=script&lang=ts&"
export * from "./LinesDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports